/**
 * Media message components (image / sticker / video / audio / document).
 *
 * These are thin, individually-importable wrappers around the existing
 * WhatsAppMediaMessage, which already implements:
 *   - authenticated lazy blob fetch via the media proxy (`mediaEndpoint/:id`),
 *   - WhatsApp-style lightbox for images/video,
 *   - graceful "not available" placeholders for legacy rows without media.
 *
 * We reuse it rather than re-implement the proxy/lightbox so there is a single
 * source of truth for media rendering. WhatsAppMediaMessage branches internally
 * on `message.messageType`, so each wrapper just forwards props.
 */
import React from "react";
import WhatsAppMediaMessage from "../WhatsAppMediaMessage";

const makeMediaWrapper = (displayName) => {
  const Comp = ({ message, mediaEndpoint }) => (
    <WhatsAppMediaMessage message={message} mediaEndpoint={mediaEndpoint} />
  );
  Comp.displayName = displayName;
  return Comp;
};

export const ImageMessage = makeMediaWrapper("ImageMessage");
export const StickerMessage = makeMediaWrapper("StickerMessage");
export const VideoMessage = makeMediaWrapper("VideoMessage");
export const AudioMessage = makeMediaWrapper("AudioMessage");
export const DocumentMessage = makeMediaWrapper("DocumentMessage");

export default WhatsAppMediaMessage;
